import { Reducer, Dispatch } from "redux";
import { SET_PAYMENT_TYPES } from "../actions/paymentTypesActions";
import { getPaymentTypes } from "../api/paymentTypes";
import { IPaymentType } from "../models/paymentType";

const initialState: IPaymentType[] = [];

export const paymentTypesReducer: Reducer<IPaymentType[]> = (
    state = initialState,
    action: any
): IPaymentType[] => {
    switch (action.type) {
        case SET_PAYMENT_TYPES:
            return action.payload;
        default:
            return state;
    }
};

export async function fetchPaymentTypes(dispatch: Dispatch) {
    const res = await getPaymentTypes();
    dispatch({ type: SET_PAYMENT_TYPES, payload: res });
}